var map = {
	"./LINE_APP.png": "5da6",
	"./baipho_logo.png": "51a4",
	"./banks/baac.png": "55b3",
	"./banks/bay.png": "0a2b",
	"./banks/bbl.png": "b92c",
	"./banks/cimb.png": "964f",
	"./banks/ghb.png": "6b4f",
	"./banks/gsb.png": "c70b",
	"./banks/ibank.png": "b077",
	"./banks/icbc.png": "e207",
	"./banks/kbank.png": "6b77",
	"./banks/kk.png": "ae9b",
	"./banks/ktb.png": "c650",
	"./banks/lhb.png": "3f09",
	"./banks/sc.png": "528b",
	"./banks/scb.png": "2400",
	"./banks/tbank.png": "9e12",
	"./banks/tcd.png": "971e",
	"./banks/tisco.png": "70bd",
	"./banks/tmb.png": "4ab2",
	"./banks/ttb.png": "f688",
	"./banks/uob.png": "5daa",
	"./coin1.png": "c688",
	"./coin100.png": "0056",
	"./coin25.png": "8e6d",
	"./coin5.png": "c13c",
	"./coin500.png": "ea75",
	"./darkgrey-background.jpg": "f996",
	"./dummy_logo.png": "ac85",
	"./indexes/index01.png": "3c2a",
	"./indexes/index02.png": "0abe",
	"./indexes/index04.png": "8435",
	"./indexes/index06.png": "5528",
	"./indexes/index08.png": "392d",
	"./indexes/index09.png": "b699",
	"./indexes/index10.png": "8da6",
	"./indexes/index11.png": "3af5",
	"./indexes/index12.png": "c7f2",
	"./indexes/index13.png": "24a6",
	"./indexes/index14.png": "ae96",
	"./indexes/index15.png": "c12b",
	"./indexes/index16.png": "7be8",
	"./indexes/index17.png": "67d2",
	"./indexes/index18.png": "746b",
	"./indexes/index19.png": "ddba",
	"./indexes/index23.png": "5e33",
	"./wangdee_logo.png": "7e57",
	"./wangdee_logo_old.png": "119d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";